"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadReport = void 0;
const file_saver_1 = require("file-saver");
const lodash_1 = __importDefault(require("lodash"));
const teamRepository_1 = require("../repositories/teamRepository");
const isEmpty = element => {
    return element === null || element === undefined || element === '';
};
const getFilenameFromHeader = (contentDisposition) => {
    const filenameRegex = /filename[^\n;=]*=((["']).*?\2|[^\n;]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        return matches[1].replaceAll(/["']/g, '');
    }
    return null;
};
const downloadReport = async (data) => {
    const { virtualCardId, cardSourceId, reportType: type, teamId, createdBefore, createdAfter } = data || {};
    const options = {
        format: 'csv',
        type,
    };
    const typeData = lodash_1.default.get(options, 'type', 'users');
    const format = lodash_1.default.get(options, 'format', 'summary');
    let path = `/rest/reports?format=${format}&type=${typeData}`;
    if (!isEmpty(virtualCardId)) {
        path += '&virtualCardId=' + virtualCardId;
    }
    else if (!isEmpty(cardSourceId)) {
        path += '&cardSourceId=' + cardSourceId;
    }
    else if (!isEmpty(teamId)) {
        path += '&teamId=' + teamId;
    }
    if (!isEmpty(createdBefore)) {
        path += '&createdBefore=' + createdBefore;
    }
    if (!isEmpty(createdAfter)) {
        path += '&createdAfter=' + createdAfter;
    }
    const report = await teamRepository_1.TeamRepository.getReport(path);
    if (report?.data) {
        const headers = report?.headers;
        let filename = `Report-${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;
        if (headers['content-disposition']) {
            const extractedFileName = getFilenameFromHeader(headers['content-disposition']);
            if (extractedFileName) {
                filename = extractedFileName;
            }
        }
        const data = new Blob([report?.data], { type: headers['content-type'] });
        (0, file_saver_1.saveAs)(data, filename);
    }
    return report;
};
exports.downloadReport = downloadReport;
